export default "__VITE_ASSET__BNMJONNb__"